import dynamic from 'next/dynamic';

const FillOutModalDynamic = dynamic(
  async () => import('./index').then((m) => m.FillOutModal),
  {
    ssr: false,
    loading: () => null,
  }
);

export { FillOutModalDynamic };
